function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0H17V17H0z",
  transform: "translate(0 .5)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.766 9.413l.002.003 4.478 4.438c.068.068.16.105.255.105s.187-.037.254-.105l4.478-4.438.002-.003.003-.002c.295-.29.528-.637.688-1.019.16-.382.242-.792.242-1.205 0-.414-.082-.824-.242-1.206-.16-.381-.393-.728-.688-1.018-.598-.59-1.404-.922-2.244-.922-.84 0-1.646.331-2.244.921l-.002.003-.003.002-.244.243-.245-.242-.002-.002-.003-.002c-.597-.59-1.404-.921-2.244-.921-.84 0-1.646.33-2.244.92-.294.292-.528.638-.687 1.02-.16.381-.242.791-.242 1.205 0 .413.082.823.242 1.205.16.382.393.728.687 1.019l.003.001z",
  clipRule: "evenodd"
});

var SvgHeartFilled = function SvgHeartFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-filled.c8aeaa7f.svg";
export { ForwardRef as ReactComponent };